import { render, staticRenderFns } from "./v2_manual_create_details.vue?vue&type=template&id=674d2c4c&scoped=true"
import script from "./v2_manual_create_details.vue?vue&type=script&lang=js"
export * from "./v2_manual_create_details.vue?vue&type=script&lang=js"
import style0 from "./v2_manual_create_details.vue?vue&type=style&index=0&id=674d2c4c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d2c4c",
  null
  
)

export default component.exports